// extracted by mini-css-extract-plugin
export var footer = "_s5-0";
export var inherit = "_s5-1";
export var input = "_s5-2";
export var modalContent = "_s5-3";
export var quillEditor = "_s5-4";
export var subtitle = "_s5-5";